<template>
  <div class="board_wrap">
    <div class="board_title">
      <h1>MES / POP</h1>
    </div>
    <div class="product">
      <div>
        <h1>MES / POP 소개</h1>
        <p>&middot; MES(Menufacturing Execution System) 생산 관리 시스템</p>
        제품의 주문 단계부터 최종 생산 단계까지의 전체 공정을 최적화하는 시스템 입니다. 생산 과정에서 문제 발생시 POP로 부터 얻은 데이터을 활용해 문제 발생 시점을 자세히 알 수 있습니다. 문제 발생 원인
        파악 및 실시간 현장 담당자에게 보고하여 빠르게 문제 해결이 가능 합니다.
        <div>
          <a>- 불량률 최소화로 제품의 품질 향상</a>
          <br />
          <a>- 업무 환경 개선으로 업무 효율성 증가</a>
          <br />
          <a>- 대품종 대량생산</a>
          <br />
          <a>- 기업의 자원관리, 에너지, 설비 효율 제고</a>
        </div>
        <p>&middot; POP(Point of Production System) 생산 시점 관리 시스템</p>
        실시간으로 현장에서 발생되는 생산 데이터를 수집, 처리, 조회 할 수 있는 시스템 입니다.
        <div>
          <a>- 기업의 자원관리, 재고비용 감소</a>
        </div>
      </div>
      <div>
        <h1>MES / POP 기본 기능</h1>
        <FormTable :info="info"></FormTable>
      </div>
    </div>
  </div>
</template>

<script>
import FormTable from '../static/FormTable.vue'
export default {
  components: { FormTable },
  data() {
    return {
      info: [
        {
          subject: '',
          element: '',
        },
        {
          subject: '',
          element: '',
        },
        {
          subject: '',
          element: '',
        },
        {
          subject: '',
          element: '',
        },
        {
          subject: '',
          element: '',
        },
        {
          subject: '',
          element: '',
        },
        {
          subject: '',
          element: '',
        },
      ],
    }
  },
}
</script>

<style scoped src="@/style/content.css"></style>
